export const DEFAULT_ADDED_GAS_LIMIT_PERCENTAGE = 20
export const SWAP_OWNER_GAS_AMOUNT = 35000
